import { useEffect } from "react";
import { useSelector } from "react-redux";

import { applyTokensToDom } from "@/features/branding/applyTokensToDom";
import type { RootState } from "@/redux/store";

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useSelector((state: RootState) => state.theme?.theme ?? "light");
  const effectiveTheme = theme;
  const brandKitTokens = useSelector((state: RootState) => state.brandKit.applied);

  useEffect(() => {
    if (typeof document === "undefined") return;

    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(effectiveTheme);

    // Set CSS custom properties for theme colors
    if (effectiveTheme === "dark") {
      root.style.setProperty("--toast-bg", "#0F172A");
      root.style.setProperty("--toast-color", "#F8FAFC");
      root.style.setProperty("--toast-border", "#1E293B");
    } else {
      root.style.setProperty("--toast-bg", "#FFFFFF");
      root.style.setProperty("--toast-color", "#0F172A");
      root.style.setProperty("--toast-border", "#E2E8F0");
    }
  }, [effectiveTheme]);

  // Brand kit tokens (sidebar colors today) apply to the light palette only — see
  // docs/plan/brand-kit/README.md §1 for why dark mode is out of scope for Phase 0.
  useEffect(() => {
    applyTokensToDom(brandKitTokens);
  }, [brandKitTokens]);

  return <>{children}</>;
}
